// The customer table's columns, shared by the Customers and Account Status
// tabs of the admin panel. openDetails(row) opens the org's details dialog.
import React from 'react';
import {Info} from '@mui/icons-material';
import {Chip, IconButton, Tooltip} from '@mui/material';

import {dateFormat, dateFromUnixEpoch} from '../../lib/utils';

const customerColumns = (openDetails) => [
  // Lean support list (2026-07-19): identity collapsed to one
  // Customer/Org cell; Username, Institute ID and the IAM /
  // Account chips moved to the details dialog. Everything a
  // row needs now comes from the DB snapshot + billing cache
  // — no live-Zitadel column remains.
  // Company (org) is the title, customer name the secondary
  // line: support scans this list by company, and the two
  // were the other way round.
  {name: 'Customer / Org', value: 'contactName', cell: (val, row) => (
    <div style={{width:200}}>
      <div style={{fontWeight: 600}}>{row.name || '--'}</div>
      <div style={{fontSize: 12, color: '#777'}}>
        {val || row.onboarding?.contactName || '--'}
      </div>
    </div>
  )},
  // Account = accounts.account_status (billing layer:
  // trial/active/blocked/terminated). Kept on the list —
  // it's DB-snapshot data (no live-Zitadel cost) and support
  // scans/sorts by it. The IAM (zitadel state) chip lives in
  // the details dialog now.
  {name: 'Account', value: 'accountStatus', cell: val => {
    const label = (val || '').toLowerCase();
    if (!label) return <span style={{color:'#999'}}>--</span>;
    const color =
      label === 'active' ? 'success' :
        label === 'trial'  ? 'info'    :
          label === 'blocked'? 'warning' :
            'error'; // terminated
    return <Chip label={label} color={color} size="small" variant="outlined" />;
  }},
  // defaultHeader + balanceCredits come from the enriched
  // ListOrganizationsV2 rows (numbers — coerced in the
  // adminPanel action adapter; never string-concatenate).
  {name: 'Header', value: 'defaultHeader', cell: val => val || <span style={{color:'#999'}}>--</span>},
  {name: 'Email', value: 'contactEmail', style:{width: 150, wordWrap: 'anywhere'}, cell: val => val || <span style={{color:'#999'}}>--</span>},
  {name: 'Mobile', value: 'mobile', cell: val => val || <span style={{color:'#999'}}>--</span>},
  {name: 'Balance', value: 'balanceCredits', cell: val => {
    if (!val || Object.keys(val).length === 0) return <span style={{color:'#999'}}>--</span>;
    const labels = {promotional: 'PROMO', transactional: 'TRANS', otp: 'OTP', general: 'GEN'};
    const order = ['otp', 'transactional', 'promotional', 'general'];
    const keys = order.filter(k => val[k] !== undefined)
      .concat(Object.keys(val).filter(k => !order.includes(k)));
    return keys.map(k => (
      <span key={"balanceadmin"+k} style={{fontSize:12,marginRight:10}}>
        {labels[k] || k} : <span style={{fontSize:16}}>{val[k].toLocaleString()}
        </span>
      </span>
    ));
  }},
  {name: 'Created Date', value: 'createdAt', style: {width: 120}, cell: (val, row) => {
    // Fall back to the onboarding signup time when the org
    // row has no created_at of its own.
    const raw = val || row.onboarding?.signedUpAt;
    if (!raw) return '--';
    // Handle both ISO string (Zitadel) and Unix epoch (legacy)
    const d = typeof raw === 'string' && raw.includes('T') ? new Date(raw) : dateFromUnixEpoch(raw);
    return isNaN(d.getTime()) ? '--' : dateFormat(d);
  }},
  {name: 'Actions', value: 'id', sticky: true, cell: (val, row) => (
    <Tooltip title="Details"><IconButton aria-label='Details' onClick={e => {e.stopPropagation();openDetails(row)}}><Info /></IconButton></Tooltip>
  )}
];

export default customerColumns;
